export default {
    /// <summary>
    /// Lương hiện thời
    /// </summary>
    KPTL_LHT: 1,

    /// <summary>
    /// Nâng lương
    /// </summary>
    KPTL_NL: 2,

    /// <summary>
    /// Phụ cấp thâm niên vượt khung
    /// </summary>
    KPTL_NPCTNVK: 3,

    /// <summary>
    /// Phụ cấp thâm niên nghề
    /// </summary>
    KPTL_NPCTNN: 4,

    /// <summary>
    /// Cải cách tiền lương
    /// </summary>
    KPTL_CCTL: 6,

    /// <summary>
    /// Kinh phí tiền lương biên chế ngân sách cấp huyện
    /// </summary>
    KPTL_12: 9,

    /// <summary>
    /// Kinh phí tiền lương của biên chế cán bộ công chức cấp xã
    /// </summary>
    KPTL_04: 11,

    KH_KPTL73: 12,

    /// <summary>
    /// Khoán kinh phí thực hiện hợp đồng theo Nghị định 111/2022/NĐ-CP  -- KH_TMH_HĐNĐ111
    /// </summary>
    KPTL_111: 10,

    /// <summary>
    /// Kinh phí hợp đồng ngân sách cấp tỉnh  -- KH_TMT_KPTL
    /// </summary>
    KPTL_KPTL: 13,

    /// <summary>
    /// Kinh phí hợp đồng ngân sách cấp tỉnh  -- KH_TMT_KPHĐ
    /// </summary>
    KPTL_KPHD: 14,

    /// <summary>
    /// Kinh phí hợp đồng ngân sách cấp tỉnh  -- KH_TMT_KPHĐ
    /// </summary>
    KPTL_15_2: 16,

    /// <summary>
    /// Báo cáo biên chế - tiền lương của các cơ quan quản lý nhà nước, đảng, đoàn thể
    /// </summary>
    KH_Bieu_15_1: 15,

    /// <summary>
    /// Nâng lương thâm niên nghề năm hiện hành (SGD Điện Biên)
    /// </summary>
    SGDDB_NTNN: 20,
}
